import { createAsyncThunk } from "@reduxjs/toolkit";
import Page from "src/constants/pages";
import { postLogin, postRegister } from "src/helpers/backend_helper";

import parseJwt from "../../common/utils/parse";
import {
  LOCAL_STORAGE_LOCK_SCREEN,
  LOCAL_STORAGE_TOKEN,
} from "../../constants/localStorageKeys";
import { lockScreenAction } from "../lockScreen/lockScreenSlice";

interface AuthPayload {
  email: string;
  password: string;
}

interface LogInUserParams {
  user: AuthPayload;
}

interface RegisterUserParams {
  user: { email: string; password: string; name?: string };
  navigate: (path: string) => void;
}

interface LogoutUserParams {
  navigate: (path: string) => void;
}

export const logInUserThunk = createAsyncThunk<
  void,
  LogInUserParams,
  { rejectValue: Error }
>("auth/logInUser", async ({ user }, { rejectWithValue }) => {
  try {
    const response = await postLogin(user);
    // dispatch(setAuthToken(response.token));
    localStorage.setItem(LOCAL_STORAGE_TOKEN, JSON.stringify(response.token));
    // if (pathname === Page.LOCK_SCREEN) {
    //   dispatch(lockScreenAction(false));
    //   localStorage.removeItem(LOCAL_STORAGE_LOCK_SCREEN);
    // }
    return parseJwt(response.token);
  } catch (error) {
    return rejectWithValue(error as Error);
  }
});

export const registerUserThunk = createAsyncThunk<
  void,
  RegisterUserParams,
  { rejectValue: Error }
>(
  "auth/registerUser",
  async ({ user, navigate }, { dispatch, rejectWithValue }) => {
    try {
      const response = await postRegister(user);
      // dispatch(setAuthToken(response.token));
      navigate(Page.CONFIRM_EMAIL);
    } catch (error) {
      return rejectWithValue(error as Error);
    }
  }
);

export const logoutUserThunk = createAsyncThunk<void, LogoutUserParams>(
  "auth/logoutUser",
  async ({ navigate }) => {
    navigate(Page.SIGN_IN);
    localStorage.removeItem(LOCAL_STORAGE_TOKEN);
    localStorage.removeItem(LOCAL_STORAGE_LOCK_SCREEN);
  }
);
